var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"loading":_vm.isLoading,"headers":_vm.headers,"items":_vm.employees,"items-per-page":5,"show-expand":"","item-key":"employee_ID"},scopedSlots:_vm._u([{key:"item.date_Of_Birth",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(_vm.formatDate(item.date_Of_Birth))+"\n    ")]}},{key:"expanded-item",fn:function(ref){
var headers = ref.headers;
var item = ref.item;
return [_c('td',{attrs:{"colspan":headers.length}},[_c('employeeEmployment',{attrs:{"tables":item.employments}})],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }